import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy, ChangeDetectorRef,
  Compiler, Component, ComponentFactory, ComponentRef, ModuleWithComponentFactories, NgModule, OnInit, ViewChild,
  ViewContainerRef
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { FaqService } from 'src/app/services/faq.service';
import { LazyLoadScriptService } from '../../lazy_load_script_service';
import { PageService } from '../../services';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {

  @ViewChild('container', { static: true, read: ViewContainerRef }) container: ViewContainerRef;

  private componentRef: ComponentRef<{}>;
  constructor(
    private service: PageService,
    public sanitizer: DomSanitizer,
    private compiler: Compiler,
    public cdRef: ChangeDetectorRef,
    private meta: Meta,
    private title: Title,
    private faqService: FaqService,
    private lazyLoadService: LazyLoadScriptService
  ) {
    this.meta.addTags([
      { name: 'description', content: 'FAQs page of UN - One HR - Salary Survey' },
      { name: 'author', content: 'One HR, Salary Survey' },
      { name: 'keyword', content: 'One HR, Salary Survey, FAQs' }
    ]);
    this.setTitle('UN - FAQs');
  }
  public setTitle(newTitle: string) {
    this.title.setTitle(newTitle);
  }
  slug = 'manage-faq';


  template: string;
  public async ngOnInit() {

    this.service.get(this.slug).subscribe((response: any) => {
      var str = response.data.html?.map(ele => ele.html).join("");
      // this.template = str;
      this.template = `
      <div class="sub-banner-new">
        <div class="align-centr-heading">
          <h1 class="heading-1 biger white" style="width:80%">Frequently Asked Questions</h1>
        </div>
      </div>
      <div class="section">
        <div class="container-fluid">
          <div class="row justify-content-md-end">
            <div class="input-group col-lg-3 col-md-3 col-sm-6 col-xs-6 m-0 p-0">
              <input type="text" class="form-control" #searchTerm placeholder="Type here..."
                aria-label="Example text with button addon" aria-describedby="button-addon1">
              <div class="input-group-append" (click)="searchTyped(searchTerm)">
                <button class="btn btn-outline-secondary" type="button" id="button-addon1">Search</button>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid">
          <div class="row" *ngIf="!searching">
            <div class="col-md-4 btm_faq_space" *ngFor="let section of faqSections">
              <div class="card faq_space" style="border-radius: 0;" data-bs-toggle="collapse"
                [attr.data-bs-target]="'#' + 'collapseExample' + section._id" aria-expanded="false"
                [attr.aria-controls]="'collapseExample' + section._id"
                (click)="scroll('collapseExample'+section._id);onSelectSection(section._id)"
                [ngClass]="{'section-title-selected': sectionId.includes(section._id)}">
                <div class="card-body faq-wrapper" [id]="'clickable' + section._id">
                  <label class="text-center clickable label_size">
                    {{section.name}}
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="!searching">
            <div *ngFor="let item of faqSections; let indx = index">
              <div class="collapse" [id]="'collapseExample' + item._id">
                <h2 class="heading-underlined-blue">{{item.name}}</h2>
                <div *ngIf="faqSections[indx] && faqSections[indx].questions?.length > 0">
                  <div *ngFor="let ques of faqSections[indx].questions">
                    <div class="mb-3 faq-link" data-bs-toggle="collapse"
                      [attr.data-bs-target]="'#' + 'collapseExample' + i + ques.section._id" aria-expanded="false"
                      [attr.aria-controls]="'collapseExample' + i + ques.section._id">
                      <b type="button">
                        <div class="d-flex justify-content-start">
                          <span style="width:20px">Q&nbsp;: </span>
                          <span class="pl-1" [innerHtml]="ques.question"></span>
                        </div>
                      </b>
                    </div>
                    <hr>
                    <div class="mb-3 collapse show" [id]="'collapseExample' + i + ques.section._id">
                      <div class="d-flex justify-content-start">
                        <b style="width:20px">A&nbsp;: </b>
                        <span class="pl-1" [innerHtml]="ques.answer"></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="faqSections[indx] && faqSections[indx].questions?.length == 0">
                  <span> Currently there is no FAQs under {{item.name}} </span>
                </div>

                <!-- <div class="mb-3 faq-link" data-toggle="collapse"
                  [attr.data-target]="'#' + 'collapseExample' + i + j + item.section._id" aria-expanded="false"
                  [attr.aria-controls]="'collapseExample' + i + j + item.section._id">
                  <b type="button">
                    <div class="d-flex justify-content-start">
                      <span style="width:20px">Q&nbsp;: </span>
                      <span class="pl-1" [innerHtml]="item.question"></span>
                    </div>
                  </b>
                </div>
                <hr>
                <div class="mb-3 collapse show" [id]="'collapseExample' + i + j + item.section._id">
                  <div class="d-flex justify-content-start">
                    <b style="width:20px">A&nbsp;: </b>
                    <span class="pl-1" [innerHtml]="item.answer"></span>
                  </div>
                </div> -->

              </div>
            </div>
          </div>
        </div>

        <div class="container-fluid" *ngIf="searching">
          <div *ngFor="let item of faqs; index as i">
            <div class="collapse show" [id]="'collapseExample' + item.section._id">
              <div class="mb-3 faq-link" data-bs-toggle="collapse"
                [attr.data-bs-target]="'#' + 'collapseExample' + i + item.section._id" aria-expanded="false"
                [attr.aria-controls]="'collapseExample' + i + item.section._id">
                <b type="button">
                  <div class="d-flex justify-content-start">
                    <span style="width:20px">Q&nbsp;: </span>
                    <span class="pl-1" [innerHtml]="item.question"></span>
                  </div>
                </b>
              </div>
              <hr>
              <div class="mb-3 collapse show" [id]="'collapseExample' + i + item.section._id">
                <div class="d-flex justify-content-start">
                  <b style="width:20px">A&nbsp;: </b>
                  <span class="pl-1" [innerHtml]="item.answer"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      `;
      this.compileTemplate();
    });
  }


  compileTemplate() {
    let metadata = {
      selector: `runtime-component-sample`,
      template: this.template,
      changeDetection: ChangeDetectionStrategy.Default
    };

    let factory = this.createComponentFactorySync(this.compiler, metadata, null, this);

    if (this.componentRef) {
      this.componentRef.destroy();
      this.componentRef = null;
    }
    this.componentRef = this.container.createComponent(factory);
    this.lazyLoadService.loadScript('/assets/js/onehr.js').subscribe(_ => {

    });
  }


  private createComponentFactorySync(compiler: Compiler, metadata: Component, componentClass: any, THIS: any,):
    ComponentFactory<any> {
    const cmpClass = componentClass || class RuntimeComponent {
      faqSections = [];
      faqs = [];
      faqBySection: any;
      searching: boolean;
      searchTerm = '';
      selectedFaqSection = {};
      sectionId: any = [];

      public ngOnInit() {
        this.loadSections();
        this.getFaqBySection();
      }

      loadSections() {
        THIS.faqService.getAllSections().subscribe(res => {
          this.faqSections = res.data;
        });
      }

      onSelectSection(section) {
        this.selectedFaqSection[section] = !this.selectedFaqSection[section];
        if (!this.sectionId.includes(section)) {
          this.sectionId.push(section)
        } else {
          let i = this.sectionId.findIndex(x => x == section)
          this.sectionId.splice(i, 1)
        }
      }

      getFaqBySection() {
        THIS.faqService.getFaqs().subscribe(res => {
          this.faqBySection = res.data;
          this.faqSections.forEach((faqs, i) => {
            const matchingFaq = res.data.filter(s => s.section._id === faqs._id);
            faqs.questions = matchingFaq;
          });
          // this.faqSections.push({questions: "1"});
          // this.faqBySection = res.data.reduce((acc, curr) => {
          //   if (!acc[curr.section._id]) {
          //     acc[curr.section._id] = [];
          //   }
          //   acc[curr.section._id].push(curr);
          //   return acc;
          // }, Object.create(null));
          setTimeout(() => {
            document.getElementById('clickable' + this.faqSections[0]._id).click();
          }, 100)
        });
      }

      getFaqSearch(search) {
        THIS.faqService.getFaqSearch(search).subscribe(res => {
          if (res.data.length >= 1) {
            this.faqs = res.data;
          } else {
            alert('no data avaliable');
          }
        });
      }

      searchTyped(searchSec) {
        this.searchTerm = searchSec.value;
        if (this.searchTerm.length > 1) {
          this.searching = true;
          this.getFaqSearch(this.searchTerm);
        } else {
          this.searching = false;
          this.sectionId = []
          this.getFaqBySection();
        }
      }

      scroll(id) {
        setTimeout(() => {
          document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    };

    const decoratedCmp = Component(metadata)(cmpClass);
    const decoratedNgModule = NgModule({
      imports: [CommonModule, CarouselModule], declarations: [decoratedCmp]
    })(cmpClass);

    const module: ModuleWithComponentFactories<any> = compiler.compileModuleAndAllComponentsSync(decoratedNgModule);
    return module.componentFactories.find(f => f.componentType === decoratedCmp);
  }

}